import { Box } from "@mui/material";
import React from "react";
import OfferImage from "../OfferImage/OfferImage";
import customImageListStyles from "../../assets/jss/material-dashboard-react/components/customImageListStyles";

const OfferImageList = ({ images, handleDelete }) => {

    return (
        <div style={customImageListStyles.root}>
            <Box sx={customImageListStyles.imageList}>
                {images?.length
                    ? images.map((image, index) => (
                        <OfferImage
                            handleDelete={() => handleDelete(image.part_offer_image_id)}
                            image={image}
                            key={image.part_offer_image_id}
                            index={index}
                        />
                    ))
                    : null}
            </Box>
        </div>
    );
};

export default OfferImageList;
